import { Box, Button, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { HousekeepingPlanAccumulatorViewStore } from '../../../stores/housekeeping-plan-accumulator.view-store'

interface Props {
  viewStore: HousekeepingPlanAccumulatorViewStore
}

export const AccumulatorListHeader: FC<Props> = observer(({ viewStore }) => {
  const { t } = useTranslate()

  return (
    <Stack spacing={1}>
      <Typography variant='captionBold'>
        {t(
          'accumulatedCount',
          '{count, plural, =0 {0 containers} one {1 container} other {# containers}} selected',
          { count: viewStore.accumulatedCount },
        )}
      </Typography>
      <Stack direction='row' spacing={1}>
        <Button
          size='small'
          variant='text'
          disabled={viewStore.accumulatedCount === 0 || viewStore.allChecked}
          onClick={() => viewStore.selectAllChecked()}
        >
          {t('selectAll', 'Select all')}
        </Button>
        <Button
          size='small'
          variant='text'
          disabled={!viewStore.hasAnyChecked}
          onClick={() => viewStore.deselectAllChecked()}
        >
          {t('deselectAll', 'Deselect all')}
        </Button>
        <Box flexGrow={1} />
        <Button
          size='small'
          color='error'
          variant='text'
          disabled={viewStore.accumulatedCount === 0}
          onClick={() => viewStore.clearAccumulator()}
        >
          {t('clearAll', 'Clear all')}
        </Button>
      </Stack>
      <Button
        size='small'
        variant='contained'
        disabled={!viewStore.hasAnyChecked}
        onClick={() => viewStore.openPlanDialog()}
      >
        {t('planMoves', 'Plan moves')}
      </Button>
    </Stack>
  )
})
